import {
  createSearchParams,
  generatePath,
  matchRoutes,
} from "react-router-dom";
import { routeURLs } from "../../utils/enums";

let reactRouterNavigate = null;
const routerRoutes = Object.values(routeURLs).map((path) => ({ path }));
export const MFE_ROUTE_CHANGE_EVENT = "va:route-change";

const getSearch = (search) => {
  if (!search) {
    return undefined;
  }

  if (typeof search === "string") {
    return search.startsWith("?") ? search : `?${search}`;
  }

  const searchParams = createSearchParams(search).toString();
  return searchParams ? `?${searchParams}` : undefined;
};

const getHash = (hash) => {
  if (!hash) {
    return undefined;
  }

  return hash.startsWith("#") ? hash : `#${hash}`;
};

const RouterWrapperService = {
  initialize: (item) => (reactRouterNavigate = item),
  notifyRouteChange: (pathname) => {
    if (typeof pathname !== "string" || pathname.length === 0) {
      console.error(
        "RouterWrapperService.notifyRouteChange: pathname must be a non-empty string"
      );
      return false;
    }

    // Keep this browser event as a compatibility adapter for deployed MFEs.
    window.dispatchEvent(
      new CustomEvent(MFE_ROUTE_CHANGE_EVENT, { detail: { pathname } })
    );
    return true;
  },
  getParams: () => {
    const pathname = window.location.pathname;
    const matches = matchRoutes(routerRoutes, pathname);
    return Array.isArray(matches) ? matches[matches.length - 1].params : {};
  },
  navigateTo: (path, options = {}) => {
    if (
      path &&
      (typeof path === "string" || typeof path.pathname === "string")
    ) {
      reactRouterNavigate(path, options);
    } else {
      console.error(
        "RouterWrapperService.navigateTo: target must be a non-empty string or a location object with pathname"
      );
    }
  },
  navigateById: (id, params, options = {}, pathOptions = {}) => {
    const routePath = routeURLs[id];
    if (routePath) {
      const path = generatePath(routePath, params ?? {});
      const search = getSearch(pathOptions.search);
      const hash = getHash(pathOptions.hash);
      const target = search || hash ? { pathname: path, search, hash } : path;
      RouterWrapperService.navigateTo(target, options);
    } else {
      console.error(
        `RouterWrapperService.navigateById: unknown route id "${id}"`
      );
    }
  },
};

export default RouterWrapperService;
